module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "title",
    staticClass: "step__title"
  }, [_c('p', [_vm._v("You’ll be the master account holder for this person.")])]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "step__subtitle"
  }, [_c('p', [_vm._v("That means you’re email will be the main point of contact and receive updates and new information.")])]), _vm._v(" "), _c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goNextStep($event)
      }
    }
  }, [_c('span', [_vm._v("Next")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44adab7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/2-blocks/Step1_AccHolder.vue
// module id = 539
// module chunks = 1